module.exports = __webpack_public_path__ + "img/博萃循环.af986050.png";